/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

/**
 * Minimum Viewport (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

(() => {
	const MIN_WIDTH = 360;

	const vp = document.querySelector('meta[name="viewport"]');
	function fn() {
		const v = window.outerWidth > MIN_WIDTH ? 'width=device-width,initial-scale=1' : `width=${MIN_WIDTH}`;
		if (vp.getAttribute('content') !== v) {
			vp.setAttribute('content', v);
		}
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
})();

/**
 * Back To Top
 *
 * @author Takuto Yanagida
 * @version 2022-10-18
 */

(() => {
	function init() {
		const OFFSET_Y = 0;

		const btn = document.getElementById('back-to-top');
		if (btn === null) return;
		const ph  = btn.parentElement;

		onScroll(scrollHandler);
		onResize(scrollHandler);
		if ('ontouchstart' in window) window.addEventListener('touchmove', scrollHandler);
		setTimeout(scrollHandler, 100);

		function scrollHandler() {
			const btnR = btn.getBoundingClientRect();
			const btnH = (btnR.bottom - btnR.top);

			const viewBottomY = window.innerHeight + OFFSET_Y - btnH;
			const footerTopY = ph.getBoundingClientRect().top;

			if (viewBottomY > footerTopY) {
				btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY) + 'px)';
				btn.classList.remove('fixed');
			} else {
				btn.style.transform = '';
				btn.classList.add('fixed');
			}

			if (window.pageYOffset > window.innerHeight / 3) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		}
	}


	// -------------------------------------------------------------------------


	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

	const resizeListeners = [];
	const scrollListeners = [];

	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}

	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}

	document.addEventListener('DOMContentLoaded', () => {
		window.addEventListener('resize', () => {
			for (const l of resizeListeners) l();
		}, { passive: true });
		window.addEventListener('scroll', () => {
			for (const l of scrollListeners) l();
		}, { passive: true });
	});

	init();
})();

/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2022-07-11
 */

 document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.stile *[class^="button"]');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (!btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		return f.classList.contains('frame') || f.classList.contains('frame-alt');
	}

	function setEventListener(btn) {
		btn.classList.add('toggle');
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		f.style.display = 'none';
		f.classList.add('hidden');
		setTimeout(() => { f.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		if (visible) {
			f.classList.remove('hidden');
		} else {
			f.classList.add('hidden');
		}
	}

});


/**
 * Bloch
 *
 * @author Space-Time Inc.
 */

document.addEventListener('DOMContentLoaded', () => {
	const can = document.querySelector('#canvas-bloch-sphere canvas');
	if (can) initFrontPage(can);

	const root = document.querySelector('#background-sphere');
	if (root) initBackground(root);

	function initFrontPage(can) {
		let hoverOnChart = false;
		const chart = document.getElementById('bloch-chart');
		chart.addEventListener('mouseenter', () => { hoverOnChart = true; });
		chart.addEventListener('mouseleave', () => { hoverOnChart = false; });
		chart.addEventListener('touchstart', () => { hoverOnChart = true; });
		chart.addEventListener('touchend', ()   => { hoverOnChart = false; });

		const ctx = can.getContext('2d');
		ctx.translate(can.width / 2, can.height / 2);
		ctx.scale(4, 4);

		const plotDots = createPlotDots();
		const loopDots = createLoopDots();

		let start = null;

		function step(t) {
			start = start ?? t;
			const elapsed = (t - start) * 0.75;

			ctx.clearRect(can.width / -2, can.height / -2, can.width, can.height);

			drawSphere(ctx, elapsed, hoverOnChart);
			drawRad(ctx, elapsed);
			drawDots(ctx, elapsed, plotDots);
			drawLoops(ctx, elapsed, loopDots);
			drawFlash(ctx, elapsed);

			window.requestAnimationFrame(step);
		}
		window.requestAnimationFrame(step);
	}

	function initBackground(root) {
		const cans = root.getElementsByTagName('canvas');

		for (let i = 0; i < cans.length; i += 1) {
			const can = cans[i];
			const ctx = can.getContext('2d');
			ctx.translate(can.width / 2, can.height / 2);
			ctx.scale(6, 6);

			let start = null;

			function step(t) {
				start = start ?? t;
				const elapsed = t - start;

				ctx.clearRect(can.width / -2, can.height / -2, can.width, can.height);

				drawRad(ctx, elapsed, 340 - i * 100, i * 3000);

				window.requestAnimationFrame(step);
			}
			window.requestAnimationFrame(step);
		}
		setTimeout(() => root.classList.add('start'), 0);
	}


	// -------------------------------------------------------------------------


	function createPlotDots() {
		const ds = [];
		for (let i = 0; i < 17; i += 1) {
			const x = (17 + Math.random() * 10) * Math.cos(Math.PI * 2 / 17 * i);
			const y = (17 + Math.random() * 10) * Math.sin(Math.PI * 2 / 17 * i);
			const p = Math.random() * Math.PI * 2;
			ds.push({ x, y, p });
		}
		return ds;
	}

	function createLoopDots() {
		const ds = [];
		for (let i = 0; i < 8; i += 1) {
			const r = 21 + Math.random() * 10;
			const x = r * Math.cos(Math.PI * 2 / 8 * i);
			const y = r * Math.sin(Math.PI * 2 / 8 * i);
			ds.push({ x, y });
		}
		return ds;
	}


	// -------------------------------------------------------------------------


	const baseHue    = 200;
	const baseRadius = 60;
	let hue    = baseHue;
	let radius = baseRadius;

	function drawSphere(ctx, elapsed, hoverOnChart) {
		const a = elapsed % 6000 / 6000;
		const o = 0.5 + 0.5 * Math.sin(Math.PI / 2 + a * Math.PI);

		hue    = hue    * 0.95 + (hoverOnChart ? 315 : baseHue)    * 0.05;
		radius = radius * 0.95 + (hoverOnChart ?  50 : baseRadius) * 0.05;

		ctx.save();
		ctx.globalCompositeOperation = 'multiply';

		for (let i = 0; i < 18; i += 1) {
			const h = hue + i * 5;
			const r = (a + i * 0.3) * 2 * Math.PI;
			const s = 0.7 - Math.pow(Math.sin((o + i * 0.7) * 2 * Math.PI / 2), 16);

			const g = ctx.createLinearGradient(-50, 0, 50, 0);
			g.addColorStop(0, `hsla(${h - 55}, 100%, 50%, 0.05)`);
			g.addColorStop(1, `hsla(${h}, 100%, 50%, 0.15)`);
			ctx.fillStyle = g;

			ctx.save();
			ctx.rotate(r);
			ctx.scale(1, s);

			ctx.beginPath();
			ctx.arc(0, 0, radius, 0, 2 * Math.PI);
			ctx.fill();
			ctx.restore();
		}
		ctx.restore();
	}

	function drawRad(ctx, elapsed, hueBase = 260, delay = 0) {
		const a = (elapsed + delay) % 12000 / 12000;
		const o = 0.5 + 0.5 * Math.sin(a * Math.PI * 2);

		ctx.save();
		ctx.globalCompositeOperation = 'screen';
		ctx.globalAlpha = o;

		for (let i = 0; i < 10; i += 1) {
			const h = hueBase + i * 5;
			const r = (a + i * 0.3) * 2 * Math.PI;
			const s = 0.7 - Math.pow(Math.sin((a + i * 0.7) * 2 * Math.PI / 2), 16);

			const g = ctx.createLinearGradient(-50, 0, 50, 0);
			g.addColorStop(0.0, `hsla(${h - 60}, 100%, 50%, 0.050)`);
			g.addColorStop(0.5, `hsla(${h - 30}, 100%, 50%, 0.025)`);
			g.addColorStop(1.0, `hsla(${h},      100%, 50%, 0.050)`);

			ctx.fillStyle = g;
			ctx.save();
			ctx.rotate(r);
			ctx.scale(o, s * o);

			ctx.beginPath();
			ctx.arc(0, 0, 80, 0, 2 * Math.PI);
			ctx.fill();
			ctx.restore();
		}
		ctx.restore();
	}

	function drawDots(ctx, elapsed, dots) {
		const a = elapsed % 3000 / 3000;

		ctx.save();
		ctx.fillStyle = '#fff';

		for (const dot of dots) {
			const { x, y, p } = dot;
			const o = 0.5 + 0.5 * Math.sin(a * Math.PI * 2 + p);

			ctx.globalAlpha = o;

			ctx.beginPath();
			ctx.arc(x, y, 0.5, 0, 2 * Math.PI);
			ctx.fill();
		}
		ctx.restore();
	}

	function drawLoops(ctx, elapsed, ds) {
		const max = ds.length - 1;
		const xc1 = (ds[0].x + ds[max].x) / 2;
		const yc1 = (ds[0].y + ds[max].y) / 2;

		ctx.save();
		ctx.lineWidth   = 0.05;
		ctx.strokeStyle = '#fffe';

		for (let i = 0; i < 6; i += 1) {
			const a = elapsed % (4000 + i * 100) / (4000 + i * 100);
			const r = (i % 2 ? 1 : -1) * 2 * Math.PI * a + i * Math.PI / 6;

			ctx.save();
			ctx.rotate(r);
			ctx.globalAlpha = 0.5 + i * 0.1;

			ctx.beginPath();
			ctx.moveTo(xc1, yc1);
			for (let i = 0; i < max; i += 1) {
				const xc = (ds[i].x + ds[i + 1].x) / 2;
				const yc = (ds[i].y + ds[i + 1].y) / 2;
				ctx.quadraticCurveTo(ds[i].x, ds[i].y, xc, yc);
			}
			ctx.quadraticCurveTo(ds[max].x, ds[max].y, xc1, yc1);
			ctx.closePath();
			ctx.stroke();
			ctx.restore();
		}
		ctx.restore();
	}

	let flashAlpha = 0;

	function drawFlash(ctx, elapsed) {
		const a = elapsed % 1000 / 1000;
		const o = 0.5 < a && 0.3 < Math.random() ? 1 : 0;

		flashAlpha = o * 0.15 + flashAlpha * 0.85;

		const g = ctx.createRadialGradient(0, 0, 0, 0, 0, 15);
		g.addColorStop(0.1, '#ffff');
		g.addColorStop(1, '#fff0');

		ctx.save();
		ctx.globalAlpha = flashAlpha;
		ctx.fillStyle   = g;

		ctx.beginPath();
		ctx.arc(0, 0, 20, 0, 2 * Math.PI);
		ctx.fill();
		ctx.restore();
	}

});

